export let oneApiUrl = process.env.REACT_APP_ONE_URL;

export function setOneApiUrl(url: string) {
    oneApiUrl = url;
}

export function getOneApiUrl() {
    if (!oneApiUrl) {
        throw new Error('One API URL is not set or undefined. Check environment variables.');
    }

    return oneApiUrl.endsWith('/') ? oneApiUrl.slice(0, -1) : oneApiUrl;
}

export class ClientSideError extends Error {
    constructor(message: string, public status: number, public body: any) {
        super(message);
    }
}

export async function callOneApi(method: string, uri: string, options: RequestInit = {}) {
    uri = uri.startsWith('/') ? uri : `/${uri}`;

    try {
        const response = await fetch(`${getOneApiUrl()}${uri}`, {
            method,
            headers: {
                'Content-Type': 'application/json',
            },
            ...options,
        });

        if (!response.ok) {
            try {
                const errorData = await response.json();
                throw new ClientSideError(errorData.message, response.status, errorData);
            } catch (error) {
                throw new Error('One API call failed with ' + response.statusText);
            }
        }

        return await response.json();
    } catch (error) {
        console.error(error);
        throw new Error('One API call failed with ' + error);
    }
}
